import { render } from "./dateComponent.vue?vue&type=template&id=d25cd7b6&scoped=true"
import script from "./dateComponent.vue?vue&type=script&lang=js"
export * from "./dateComponent.vue?vue&type=script&lang=js"

import "./dateComponent.vue?vue&type=style&index=0&id=d25cd7b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d25cd7b6"]])

export default __exports__